import React, { forwardRef, memo, useEffect } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./TextEditor.css";
import { SurveyFormClipboard } from "./PlainClipboard";

Quill.register("modules/clipboard", SurveyFormClipboard, true);
const TextEditor = forwardRef(function TextEditor(
  { disabled, value, onChange, className },
  ref
) {
  //   const [value, setValue] = useState("");
  useEffect(() => {
    const qlDirection = document.getElementsByClassName("ql-direction");
    [...qlDirection].forEach((btn) => {
      if (!btn.classList.contains("ql-active")) {
        btn.click();
      }
    });
  }, []);
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      // ['blockquote', 'code-block'],

      // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ list: "ordered" }, { list: "bullet" }],
      // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ direction: "rtl" }], // text direction

      [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      // [{ 'font': [] }],
      [{ align: [] }],

      ["clean"],
    ],
  };

  // const formats = [
  //     'header',
  //     'bold', 'italic', 'underline', 'strike', 'blockquote',
  //     'list', 'bullet', 'indent',
  //     'link', 'image'
  //   ]

  return (
    <div
      className={["TextEditorContainer", disabled ? "disabled" : null].join(
        " "
      )}
    >
      <style>
        {`
.ql-editor {
  direction: rtl;
  text-align: right;
  min-height: 15rem;
}
`}
      </style>
      <ReactQuill
        style={{ direction: "rtl !important" }}
        ref={ref}
        className={className}
        // formats={formats}
        modules={modules}
        theme="snow"
        value={value}
        onChange={onChange}
        onBlur={(prev, source, editor) => {
          onChange(editor?.getHTML());
        }}
      ></ReactQuill>
    </div>
  );
});

export default memo(TextEditor);
